import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { ContactHelper } from 'src/app/helpers/contact-helper';
import { StringHelper } from 'src/app/helpers/string-helper';
import Company from 'src/app/model/company/company';
import ProjectContact from 'src/app/model/company/projectContact';
import SubProjectContact from 'src/app/model/company/subProjectContact';
import Contact from 'src/app/model/Contact/contact';
import LoggedAction from 'src/app/model/logged-action';
import Address from 'src/app/model/project/address';
import { ProjectExtraCompanyContact } from 'src/app/model/project/project-extra-company-contact';
import { FormatPhoneNumber } from 'src/app/modules/app-pipes/format-phonenumber';
import {
  GroupProjectContactPipe,
  ProjectContactGroup
} from 'src/app/pipes/group-project-contact';
import { AuthService } from 'src/app/services/auth.service';
import { ModalService } from 'src/app/services/modal.service';

@Component({
  selector: 'client-adjustment-header',
  templateUrl: './client-adjustment-header.component.html',
  styleUrls: ['./client-adjustment-header.component.scss'],
  providers: [FormatPhoneNumber, GroupProjectContactPipe]
})
export class ClientAdjustmentHeaderComponent implements OnInit, OnChanges {
  @Input()
  title: string;

  @Input()
  type: string;

  @Input()
  currentCreatedAt: Date = new Date();

  @Input()
  projectContacts: ProjectContact[];

  @Input()
  requestContact?: SubProjectContact;

  @Input()
  extraCompanyContacts?: ProjectExtraCompanyContact[];

  @Input()
  showTime: boolean = true;

  @Input()
  client: boolean;

  @Input()
  placer: boolean = false;

  @Input()
  approved: boolean = false;

  @Input()
  approvedRegistration?: LoggedAction;

  @Input()
  projectId?: number;

  @Input()
  address?: Address;

  @Output()
  impersonateClicked = new EventEmitter();

  projectContactGroups: ProjectContactGroup[] = [];
  showExtraContacts: boolean = true;

  constructor(
    private formatPhoneNumber: FormatPhoneNumber,
    private groupProjectContactPipe: GroupProjectContactPipe,
    private modalService: ModalService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.projectContacts.forEach(c => {
      ContactHelper.setFormDisplays(c.contact, this.formatPhoneNumber);
    });
    if (this.requestContact != null) {
      ContactHelper.setFormDisplays(
        this.requestContact.contact,
        this.formatPhoneNumber
      );
    }

    this.projectContactGroups = this.groupProjectContactPipe.transform(
      this.projectContacts
    );
    this.showExtraContacts =
      this.projectContactGroups != null &&
      this.projectContactGroups.length <= 1;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['projectContacts']) {
      this.projectContacts.forEach(c => {
        ContactHelper.setFormDisplays(c.contact, this.formatPhoneNumber);
      });

      this.projectContactGroups = this.groupProjectContactPipe.transform(
        this.projectContacts
      );
      this.showExtraContacts =
        this.projectContactGroups != null &&
        this.projectContactGroups.length <= 1;
    }
  }

  impersonateProjectContact(
    subProjectContact: SubProjectContact,
    company: Company
  ): void {
    if (subProjectContact != null && subProjectContact.contactUserId != null) {
      const name =
        subProjectContact.contact != null
          ? StringHelper.join(
              [
                subProjectContact.contact.firstName,
                subProjectContact.contact.lastName
              ],
              ' '
            )
          : '';
      this.impersonate(
        name,
        subProjectContact.contactUserId,
        company != null ? company.id : null
      );
    }
  }

  impersonateContact(subProjectContact: Contact, company: Company): void {
    if (subProjectContact != null && subProjectContact.contactUserId != null) {
      const name = StringHelper.join(
        [subProjectContact.firstName, subProjectContact.lastName],
        ' '
      );
      this.impersonate(
        name,
        subProjectContact.contactUserId,
        company != null ? company.id : null
      );
    }
  }

  impersonate(name: string, userId: number, companyId: number): void {
    this.modalService.confirmDialog(
      `${name} nabootsen`,
      `Bent u zeker dat u ${name} wilt nabootsen?`,
      (b: boolean) => {
        if (b) {
          this.impersonateClicked.emit();
          this.authService.impersonateUser({
            id: userId
          });
          if (companyId != null) {
            localStorage.setItem('lastSelectedCompanyId', companyId.toString());
          }
        }
      }
    );
  }
}
